const EndOfDay = () => import(/* webpackChunkName: "endOfDay" */ '@/components/dashboard/endOfDay')
export default {
    name: 'endOfDay',
    path: 'end-of-day',
    redirect: '/end-of-day/index',
    meta: {label: 'endOfDay'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'endOfDay', auth: [0, 1, 2, 3, 4, 5, 6, 7, 10]},
            component: EndOfDay,
            props: true
        }
    ]
}
